import React from "react";
import MainNav from "components/MainNav";

function Header() {
  return <MainNav />;
}

export default Header;
